import { ShipmentSearchResult } from './shipment-search-result';

export const getShipmentSearchResultPrices = ({
	targetPrice,
	targetShipmentFee,
	targetTotalPrice,
	agreedPrice,
	agreedShipmentFee,
	agreedTotalPrice,
}: ShipmentSearchResult) => {
	const isShipmentMatched = !!agreedPrice;
	const price = isShipmentMatched ? agreedPrice : targetPrice;
	const feeValue = isShipmentMatched ? agreedShipmentFee : targetShipmentFee;
	const totalPrice = isShipmentMatched ? agreedTotalPrice : targetTotalPrice;
	return { isShipmentMatched, price, feeValue, totalPrice };
};
